import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import "./verifySignUpOTP.css";
import Logo from "../../../Components/Logo/Logo";
import { jwtDecode } from "jwt-decode";
import axiosInstance from "../../../Config/axiosConfig";

function VerifySignUpOTP({ setLoggedIn }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  
  
  // Get state from navigation - now expecting both email and phoneNumber
  const { email, phoneNumber, deviceId, userIp } = location.state || {};

  const handleResendOtp = async (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    const username = email || phoneNumber;
    
    if (!username) {
      message.error("Username is required to resend OTP");
      return;
    }
    
    setResendLoading(true);
    const storedDeviceId = deviceId;
    const storedUserIp = userIp;

    try {
      const response = await axiosInstance.post(
        "/User/account-reset",
        { username }, // Send username in the request body
        {
          headers: {
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          },
        }
      );
      console.log("Reset OTP response:", response.data);
      
      // Show success message
      message.success(response.data.message || "OTP has been resent successfully");
      
      // You might want to reset any OTP input field if needed
      // form.resetFields(['otp']); // Uncomment if using form reference
      
    } catch (error) {
      console.error("Resend OTP error:", error);
      message.error(
        error.response?.data?.message ||
        "Failed to resend OTP. Please try again."
      );
    } finally {
      setResendLoading(false);
    }
  };

  const handleVerifyOTP = async (values) => {
    // Check if either email or phoneNumber exists
    if (!email && !phoneNumber) {
      message.error("Contact information not found. Please try signing up again.");
      navigate("/signup");
      return;
    }

    setLoading(true);
    try {
      // Determine the username parameter based on what was provided
      const username = email || phoneNumber;
      
      const response = await axiosInstance.post("/User/verify-otp",
        {
          username: username,
          otp: values.otp
        },
        {
          headers: {
            UserDevice: deviceId,
            UserIPAddress: userIp,
          },
        }
      );
      console.log("Verify OTP response:", response.data);
      if (response.data.code === 200) {
        const token = response.data.data.jwt; 
        localStorage.setItem("accessToken", token);
        
        // Decode token and store user info
        const decodedToken = jwtDecode(token);
        localStorage.setItem("userInfo", JSON.stringify({
          name: decodedToken.name,
          username: decodedToken.username,
          role: decodedToken.role,
          exp: decodedToken.exp,
          userId: decodedToken.userId
        }));

        setLoggedIn(true);
        message.success(response.data.message || "Account verified successfully!");
        navigate("/"); // Redirect to home page after successful verification
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || 
        "Failed to verify OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // Display appropriate message based on contact method
  const getContactMessage = () => {
    if (email) {
      return `Enter one-time-pin sent to ${email}`;
    } else if (phoneNumber) {
      return `Enter one-time-pin sent to ${phoneNumber}`;
    }
    return "Enter one-time-pin sent to your contact";
  };

  return (
    <div className="verify-otp-page-container">
      <div className="verify-otp-container">
        <Logo />
        <h3>Account Verification</h3>
        <span className="verify-otp-text">{getContactMessage()}</span>

        <Form className="verify-otp-form" layout="vertical" onFinish={handleVerifyOTP}>
          <Form.Item
            name="otp"
            rules={[
              { required: true, message: "Please enter OTP" },
              { pattern: /^\d{6}$/, message: "OTP must be 6 digits" }
            ]}
          >
            <Input 
              prefix={email ? <MailOutlined /> : <PhoneOutlined />} 
              placeholder="Enter 6-digit OTP" 
              className="verify-otp-input" 
              maxLength={6}
            />
          </Form.Item>

          <Button 
            type="primary" 
            htmlType="submit" 
            className="verify-otp-button" 
            loading={loading}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </Button>
        </Form>
         <span className="resend-otp-text">
          Didn't receive the OTP? 
          <a 
            href="#" 
            onClick={handleResendOtp}
            style={{ pointerEvents: resendLoading ? 'none' : 'auto', opacity: resendLoading ? 0.6 : 1 }}
          >
            {resendLoading ? "Resending OTP..." : "Resend OTP"}
          </a>
        </span>
      </div>
    </div>
  );
}

export default VerifySignUpOTP;